import { ReactNode } from "react";
import { PLACEHOLDER } from "../../authorisationDetails/utils/constants";

interface LabelledValueProps {
  label: string;
  value?: string | null;
  /** Rendered in place of the text value (e.g. a status tag). */
  children?: ReactNode;
  fullWidth?: boolean;
}

/**
 * Class list of a section-grid cell; full-width cells span the whole row.
 *
 * @param fullWidth - Whether the cell spans the row
 * @returns The cell's class names
 */
export const fieldClassName = (fullWidth = false): string =>
  [
    "authorisation-details__field",
    fullWidth && "authorisation-details__field--full",
  ]
    .filter(Boolean)
    .join(" ");

/** One label-over-value cell in an Authorization Details section grid. */
const LabelledValue = ({
  label,
  value,
  children,
  fullWidth = false,
}: LabelledValueProps) => (
  <div className={fieldClassName(fullWidth)}>
    <div className="authorisation-details__label font-semibold">{label}</div>
    {children ?? (
      <span className="authorisation-details__value">
        {value?.trim() ? value : PLACEHOLDER}
      </span>
    )}
  </div>
);

export default LabelledValue;
